import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import {
    HisSearchResultComponent, HisAuthService, HisUiService, HisNavigationService, HisNotificationService, HisConfirmationService,
    HisGlobalDataService, Notification
} from 'hisng';

import { CONFIRMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/confirmation-dialog.component';
import { INFORMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/information-dialog.component';
import { NOTIFICATION } from 'app/fs/res/publication/model/constants';
import { PublicationModuleOptions } from '../../../publication-module.options';
import { PublicationService } from 'app/fs/res/publication/service/publication.service';

@Component( {
    selector: 'res-publication-search-result',
    templateUrl: './publication-search-result.component.html'
} )
export class PublicationSearchResultComponent implements OnInit {

    public readonly moduleOptions = PublicationModuleOptions;

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;

    public showBackButton = false;

    constructor( public auth: HisAuthService,
        private route: ActivatedRoute,
        private confirmationService: HisConfirmationService,
        private notificationService: HisNotificationService,
        private globalDataService: HisGlobalDataService,
        public navigationService: HisNavigationService,
        public publicationService: PublicationService, // not private because used in the template
        private hisUiService: HisUiService ) {
    }

    ngOnInit() {
        this.publicationService.userProfileService.getValueforKey('searchResultview').subscribe( (value: string) => {
            if (value==='Liste') {
                this.publicationService.switchListTable('searchResultview', true);
            }
            else{
                this.publicationService.switchListTable('searchResultview', false);
            }
        });

        this.route.queryParams.subscribe( (queryParams: Params) => {
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
        });

        // gegebenenfalls Meldung ausgeben, die von der vorherigen Seite (z.B. Duplikatsseite) gesetzt wurde
        let notification = this.globalDataService.getData(NOTIFICATION) as Notification;
        if (notification) {
            this.notificationService.notify(notification);
            this.globalDataService.removeData(NOTIFICATION);
        }
    }

    /* callback to set last window location href */
    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl( window.location.href );
    }

    /* delete selected publication from database */
    deleteRow( publicationRow: any ) {
        this.publicationService.canDeletePublication( publicationRow.get( 'Publication.id' ) ).subscribe( (canDelete: string) => {
            if ( canDelete === '' ) {
                this.confirm( 'fs.res.publication.confirmDeletePublication', publicationRow, canDelete );
            } else {
                this.confirm( canDelete, publicationRow, canDelete );
            }
        } );
    }

    page( event: { first: number; rows: number } ) {
        this.searchResultComponent.loadPage( event.first );
        this.searchResultComponent.onPage( event );
    }

    /**
     * confirmation service to load confirmation-/information dialog
     *
     * @param msg dialog message
     * @param publicationRow publication (object) to delete
     * @param canDelete identifier publication can be deleted
     */
    private confirm( msg: string, publicationRow: any, canDelete: string ) {
        this.confirmationService.confirm( {
            key: canDelete === '' ? CONFIRMATION_PDIALOG_KEY : INFORMATION_PDIALOG_KEY,
            message: canDelete === '' ? this.hisUiService.translate( msg, publicationRow.get( 'Publication.title' ) ) : canDelete,
            accept: () => {
                if ( canDelete === '' ) {
                    let publicationId = publicationRow.get( 'Publication.id' );
                    this.publicationService.deletePublication( publicationId ).subscribe( (deleteSuccess: number) => {
                        if ( deleteSuccess === 1 ) {
                            this.notificationService.deleteSuccessI18nRes();
                            this.searchResultComponent.reloadPageAfterDelete();
                        }
                    } );
                }
            }
        } );
    }

    getViewlinkQueryParams() {
        return {
            showBackButton: this.showBackButton,
            showSearchButton: true,
            prevPage: 'pubSearch'
        };
    }

    getEditlinkQueryParams() {
        return {
            showBackButton: this.showBackButton,
            showSearchButton: true,
            showDeleteButton: false,
            prevPage: 'pubSearch'
        };
    }
}
